import React, { useEffect, useState, useRef } from "react";
import AdminCategoryList from "../../components/AdminCategoryBlock/AdminCategoryList/AdminCategoryList";
import AdminCategoryCreate from "../../components/AdminCategoryBlock/AdminCategoryCreate/AdminCategoryCreate";
import AdminCategoryEdit from "../../components/AdminCategoryBlock/AdminCategoryEdit/AdminCategoryEdit";
import Card from "../../components/ConfigurationCards";
import PortalModal from "../../Portals";
import {
  ContentLoader,
  TableViewButton,
  ActionSection,
} from "./AdminCategoryContainer.styled";
import { ALL_ADMIN_CATEGORIES } from "../../GraphQL/Queries";
import {
  CATEGORY_CHANGE_STATE,
  CREATE_WELLNESS_CATEGORY,
  UPDATE_WELLNESS_CATEGORY,
} from "../../GraphQL/Mutations";
import { useMutation, useLazyQuery } from "@apollo/client";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { NotificationManager } from "react-notifications";
import { clientWellness } from "../../App";
import ViewList from "@material-ui/icons/ViewList";
import ViewCards from "@material-ui/icons/ViewModule";
import { Tooltip } from "@material-ui/core";
import SearchComponent from "../../components/SearchComponent/SearchComponent";

const AdminCategoryContainer = () => {
  const [openCreateCategory, setOpenCreateCategory] = useState(false);
  const [openEditCategory, setOpenEditCategory] = useState(false);
  const [changeStateCategory] = useMutation(CATEGORY_CHANGE_STATE, {
    client: clientWellness,
  });
  const [createCategory] = useMutation(CREATE_WELLNESS_CATEGORY, {
    client: clientWellness,
  });
  const [editCategory] = useMutation(UPDATE_WELLNESS_CATEGORY, {
    client: clientWellness,
  });
  const [categories, setCategories] = useState([]);
  const [dataEdit, setDataEdit] = useState();
  const [dataDelete, setDataDelete] = useState();
  const [stateCreate, setStateCreate] = useState(false);
  const [stateEdit, setStateEdit] = useState(false);
  const [stateChangeState, setStateChangeState] = useState(false);
  const [showCards, setShowCards] = useState(true);

  const [runQueryAllAdminCategories, { loading: loadingCategories }] =
    useLazyQuery(ALL_ADMIN_CATEGORIES, {
      client: clientWellness,
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let resultOfAllEventCategories = data.allCategories
          .map((o) => ({ ...o }))
          .filter((el) => el.recordState !== "Deleted");

        setCategories(resultOfAllEventCategories);
      },
    });

  const [searchTxt, setSearchTxt] = useState("");
  const rSearch = useRef();
  const getDataBySearch = () => {
    setSearchTxt(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch();
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  useEffect(() => {
    runQueryAllAdminCategories({
      variables: {
        searchBy: searchTxt,
      },
    });
  }, [searchTxt]);

  useEffect(() => {
    if (dataEdit) {
      setOpenEditCategory(true);
    }
  }, [dataEdit]);

  useEffect(() => {
    if (dataDelete) {
      changeStateCategoryhandler(dataDelete.idCategory, "Deleted");
    }
  }, [dataDelete]);

  const deleteHandler = (data) => {
    setDataDelete(data);
  };

  const openModal = () => {
    setOpenCreateCategory(true);
  };

  const changeStateCategoryhandler = (categoryId, newRecordState) => {
    setStateChangeState(true);

    changeStateCategory({
      variables: {
        categoryId: categoryId,
        newRecordState: newRecordState,
      },
    }).then(
      (saveResponse) => {
        setStateChangeState(false);
        if (saveResponse.errors) {
          NotificationManager.warning(saveResponse.errors[0].message, "", 5000);
        } else {
          if (newRecordState.toLowerCase() === "deleted") {
            setCategories((prev) =>
              prev.filter((x) => x.idCategory !== categoryId)
            );
            NotificationManager.success(
              "Category was deleted successfully",
              "",
              5000
            );
          } else {
            NotificationManager.success(
              "Your information has been sent, Thank you!",
              "",
              5000
            );
          }
        }
      },
      (error) => {
        setStateChangeState(false);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      }
    );
  };

  const createCategoryhandler = (categoryName, codeColor) => {
    if (categoryName && codeColor) {
      setStateCreate(true);

      createCategory({
        variables: {
          categoryName: categoryName,
          codeColor: codeColor,
        },
      }).then(
        (saveResponse) => {
          if (saveResponse.errors) {
            NotificationManager.error(saveResponse.errors[0].message, "", 5000);
          } else {
            setStateCreate(false);
            runQueryAllAdminCategories();

            NotificationManager.success(
              "Category was created successfully",
              "",
              5000
            );

            setOpenCreateCategory(false);
          }
        },
        (error) => {
          setStateCreate(false);
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        }
      );
    } else {
      NotificationManager.warning(
        "Please type a category name before saving changes",
        "",
        5000
      );
    }
  };

  const editCategoryhandler = (categoryId, categoryName, codeColor) => {
    if (categoryName && codeColor) {
      setStateEdit(true);

      editCategory({
        variables: {
          categoryId: categoryId,
          categoryName: categoryName,
          codeColor: codeColor,
        },
      }).then(
        (saveResponse) => {
          setStateEdit(false);
          runQueryAllAdminCategories();

          NotificationManager.success(
            "Category was updated successfully",
            "",
            5000
          );

          setOpenEditCategory(false);
        },
        (error) => {
          setStateEdit(false);
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        }
      );
    }
  };

  return (
    <>
      {(loadingCategories || stateCreate || stateEdit || stateChangeState) && (
        <ModalLoader></ModalLoader>
      )}
      {openCreateCategory && (
        <PortalModal>
          <ContentLoader>
            <AdminCategoryCreate
              setClose={setOpenCreateCategory}
              createCategoryhandler={createCategoryhandler}
            ></AdminCategoryCreate>
          </ContentLoader>
        </PortalModal>
      )}
      {openEditCategory && (
        <PortalModal>
          <ContentLoader>
            <AdminCategoryEdit
              setClose={setOpenEditCategory}
              editCategoryhandler={editCategoryhandler}
              setData={dataEdit}
            ></AdminCategoryEdit>
          </ContentLoader>
        </PortalModal>
      )}
      <ActionSection>
        <Card
          iconplusactive={false}
          coloricon="#FFFFFF"
          icon="plus"
          code="category"
          title="New Event Category"
          subtitle="Category Administration"
          footerText="New Event Category"
          setFormTrigger={openModal}
          customStyle={{ marginLeft: "0" }}
        />
        <div className="right-section">
          <SearchComponent
            rSearch={rSearch}
            handleSearch={handleSearch}
            setSearchText={setSearchTxt}
          />
          <div className="table-action">
            <Tooltip title="View List">
              <TableViewButton
                iconColor={showCards}
                onClick={() => setShowCards(false)}
                className="MuiButtonBase-root MuiIconButton-root"
              >
                <span
                  style={{ width: "fit-content" }}
                  className="MuiIconButton-label"
                >
                  <ViewList className="list-view" />
                </span>
              </TableViewButton>
            </Tooltip>
            <Tooltip title="View Cards">
              <TableViewButton
                iconColor={showCards}
                onClick={() => setShowCards(true)}
                style={{ borderLeft: "none" }}
                className="MuiButtonBase-root MuiIconButton-root"
              >
                <span
                  style={{ width: "fit-content" }}
                  className="MuiIconButton-label"
                >
                  <ViewCards className="card-view" />
                </span>
              </TableViewButton>
            </Tooltip>
          </div>
        </div>
      </ActionSection>

      <AdminCategoryList
        categories={categories}
        changeStateCategoryhandler={changeStateCategoryhandler}
        editHandler={setDataEdit}
        deleteHandler={deleteHandler}
        showCards={showCards}
        setShowCards={setShowCards}
      ></AdminCategoryList>
    </>
  );
};

export default AdminCategoryContainer;
